// Import React helper
import {
    // Import useContext
    useContext,
} from "react";



// Import the config context
import { AppConfigContext } from "global/context/AppConfigContext";



// Export the custom config hook
export const useAppConfig = () => {

    // Read the config from context
    const config = useContext(AppConfigContext);

    // Guard against missing provider
    if (!config) {

        // Throw a helpful error
        throw new Error("useAppConfig must be used inside AppConfigContext.Provider.");

    }

    // Return the loaded config
    return config;

};